import axiosInstance from "../axiosInstance";

export const getPendingService = async () => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const response = await axiosInstance.get("/get_pending_data", {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching partner  data", error);
    throw error;
  }
};

export const cancelPendingServiceOrder = async (data) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const response = await axiosInstance.post("/cancel_order", data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending order form data", error);
    throw error;
  }
};
